import { makeStyles } from '@rbx/ui';

const useOpenSourceEditButtonStyles = makeStyles()((theme) => ({
  btnWrapper: {
    display: 'flex',
    alignItems: 'items-center',
    textDecoration: 'inherit',
  },
  icon: {
    marginLeft: theme.spacing(1),
  },
  iconRevamp: {
    marginRight: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  buttonRevamp: {
    color: theme.palette.content.muted,
  },
}));

export default useOpenSourceEditButtonStyles;
